<template>
  <div class="input-container">
    <input class="input text"
        :placeholder="enterMessageText"
        :maxlength="maxMessageLength"
        @keyup.enter="processEnter"
        v-model.trim="text">
    <img class="send-img"
         src="../assets/send.png"
         @click="processEnter">
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'MessageInput',

  data: function () {
    return {
      text: ''
    }
  },

  computed: {
    ...mapGetters([
      'enterMessageText',
      'maxMessageLength'
    ])
  },

  methods: {
    ...mapActions([
      'sendMessage'
    ]),

    processEnter (e) {
      this.text = this.text.replace(/(\r\n|\n|\r)/gm, '')
      if (!this.text) {
        return
      }

      this.sendMessage({ text: this.text })
      this.text = ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';

.input-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.send-img {
  position: absolute;
  margin: auto 5px auto auto;
  top: 0;
  bottom: 0;
  right: 0;
  height: 25px;
  transition: transform .1s ease-in-out;

  &:active {
    transform: scale(1.1);
  }
}

.input {
    width: 100%;
    height: 100%;
    outline: none;
    resize: none;
    border-top: 1px solid $border-color;
    border-left: 0px;
    border-right: 0px;
    border-bottom: 0px;
    padding: 0px 35px 0px 10px;

    /* Fix input in iOS */
    appearance: none;
    border-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/MessageInput.vue